import * as yup from "yup";

const restrictedNumbers = [
  "0000000000", "1111111111", "2222222222", "3333333333",
  "4444444444", "5555555555", "6666666666", "7777777777",
  "8888888888", "9999999999", "1234567890", "9876543210", "0987654321"
];

export const CreateOrderSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  contactNumber: yup
    .string()
    .required("Contact number is required")
    .matches(/^\d{10}$/, "Contact number must be exactly 10 digits")
    .notOneOf(restrictedNumbers, "This contact number is not allowed."),
  orderId: yup.string().required("Order is required"),
});
